export default __webpack_public_path__ + "static/media/checked.08385652.svg";